import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Menu, MenuItem} from '@progress/kendo-react-layout';

import '../styles/App.css';
import data from '../json/vineyards.json';

class MenuNavContainer extends Component {

    render() {

        // let menuItems = data.map(item =>
        //     <MenuItem text={ item.vineyard } data={{route: '/vineyards/' + item.id }} />
        // );
        return (
            <div className="container-fluid">
                <div className="row flex-xl-nowrap">
                    <div className="navigation">
                        <div className="menu">
                            <Menu
                                vertical={true}
                                className="menu-container"
                                onSelect={this.onSelect}
                            >
                                <MenuItem text="Home" data={{route: '/'}}/>
                                <MenuItem text="Tableau récapitulatif" data={{route: '/vineyards'}}>
                                    {/*{menuItems}*/}
                                </MenuItem>
                                <MenuItem text="A propos" data={{route: '/about'}}>
                                    <MenuItem text="Team" data={{route: '/about/team'}}/>
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                    <main className="py-md-3 content">
                        {this.props.children}
                    </main>
                </div>
            </div>
        );
    }

    onSelect = (event) => {
        this.props.history.push(event.item.data.route);
    }
}

export default withRouter(MenuNavContainer);
